import axios from 'axios';

// Prod - http://150.230.77.133:3333/api/v1
// Dev - http://127.0.0.1:3333/api/v1
// Local - http://192.168.90.24:3333/api/v1

let baseURL = process.env.REACT_APP_API_DEV;
if (process.env.REACT_APP_ENVIRONMENT === 'production') {
  baseURL = process.env.REACT_APP_API_PROD;
} 
else if (process.env.REACT_APP_ENVIRONMENT === 'staging') {
  baseURL = process.env.REACT_APP_API_STAG;
}

axios.defaults.baseURL = baseURL;
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common.Accept = 'application/json';
axios.defaults.headers.common.Accept = 'Access-Control-Allow-Origin", "*"';
axios.defaults.headers.common.Accept = '"Access-Control-Allow-Headers", "Origin, X-Requested-With, Content-Type, Accept"';

const http = axios.create({
	headers: { 
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Headers': "*",
    'Access-Control-Allow-Origin': "*"
  }
});

http.interceptors.request.use(async config => {
  const token = await localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.params = { ...config.params, timestamp: Date.now() };
  return config;
},
  err => {
    return Promise.reject(err.response?.data ? err.response.data : err);
  }
);

http.interceptors.response.use(response => {
  return response;
}, 
  err => {
    return Promise.reject(err.response?.data ? err.response.data : err);
  }
);

const auth = async (cpf, senha) => {
  return http.post('/auth', { cpf, senha }).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    console.log(err);
    return Promise.reject(err);
  });
};

const getUsuario  = async () => {
  return http.post(`/usuarios/buscar`).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    return Promise.reject(err);
  });
};

const dataHoraServidor = async (timezone) => {
  return http.post(`/usuarios/datahoraservidor?cb=${Date.now()}`, { timezone }).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    console.log(err);
    return Promise.reject(err);
  });
}

const alteraSenha = async (senha, senhaAtual, confirmarSenha) => {
  return http.post('/usuarios/alterasenha', { senha, senhaAtual, confirmarSenha }).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    console.log(err);
    return Promise.reject(err);
  });
};

const aceiteLgpd = async (id) => {
  return http.put('/usuarios/aceitelgpd', { id }).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    console.log(err);
    return Promise.reject(err);
  });
};

const aceitouLgpd = async (id) => {
  return http.post('/usuarios/aceitelgpd', { id }).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    console.log(err);
    return Promise.reject(err);
  });
};

const solicitaRecuperarSenha = async (cpf, dtNascim) => {
  return http.post('/usuarios/solicitarecuperarsenha', { cpf, dtNascim }).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    console.log(err);
    return Promise.reject(err);
  });
};

const confirmaCodigoVerificacao = async (token, codigoVerificacao) => {
  return http.post('/usuarios/confirmacodigoverificacao', { token, codigoVerificacao }).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    console.log(err);
    return Promise.reject(err);
  });
};

const recuperarSenha = async (token, codigoVerificacao, senha, confirmarSenha) => {
  return http.post('/usuarios/recuperarsenha', { token, codigoVerificacao, senha, confirmarSenha }).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    console.log(err);
    return Promise.reject(err);
  });
};

const trocaSenha = async (senha, confirmarSenha) => {
  return http.post('/usuarios/trocasenha', { senha, confirmarSenha }).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    console.log(err);
    return Promise.reject(err);
  });
};

const notificationId = async (notificationId) => {
  return http.post('/usuarios/notificationid', { notificationId }).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    console.log(err);
    return Promise.reject(err);
  });
};

const confirmarDados = async (email, dtNascim) => {
  return http.post('/usuarios/confirmardados', { email, dtNascim }).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    console.log(err);
    return Promise.reject(err);
  });
};

const registraBatida = async (token) => {
  return http.post('/batidas', { token }).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    console.log(err);
    return Promise.reject(err);
  });
};

const buscarBatidas = async (mes, ano) => {
  return http.post('/batidas/buscarbatidas', { mes, ano }).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    console.log(err);
    return Promise.reject(err);
  });
};

const cadastrarJustificativa = async (justificativa) => {
  return http.post('/batidas/cadastrarjustificativa', justificativa).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    console.log(err);
    return Promise.reject(err);
  });
};

const getSituacoes = async (dataRef) => {
  return http.post('/situacoes/buscar', { dataRef }).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    console.log(err);
    return Promise.reject(err);
  });
};

const getFeriados = async (dataRef) => {
  return http.post('/feriados/buscar', { dataRef }).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    console.log(err);
    return Promise.reject(err);
  });
};

const upload = async (formData) => {
  return http.post('/arquivos/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  }).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    console.log(err);
    return Promise.reject(err);
  });
};

const alteraEmail = async (email, emailAtual, confirmarEmail) => {
  return http.post('/usuarios/alteraemail', { email, emailAtual, confirmarEmail }).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    console.log(err);
    return Promise.reject(err);
  });
};

const emitirComprovante = async (batida) => {
  return http.post('/batidas/comprovante', { batida }).then(response => {
    return Promise.resolve(response.data);
  }).catch(err => {
    console.log(err);
    return Promise.reject(err);
  });
};

export default { 
  auth, 
  getUsuario, 
  dataHoraServidor, 
  alteraSenha,
  aceiteLgpd,
  aceitouLgpd,
  solicitaRecuperarSenha, 
  confirmaCodigoVerificacao,
  recuperarSenha,
  trocaSenha,
  notificationId,
  confirmarDados,
  registraBatida,
  buscarBatidas,
  cadastrarJustificativa,
  getSituacoes,
  getFeriados,
  upload,
  alteraEmail,
  emitirComprovante
};
